import React from 'react';
import {  Grid, Typography, Paper } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { useDispatch, useSelector } from 'react-redux'
import { obtenerlistadepta, obtenerlistaempresa } from '../../../Redux/DepartamentosDucks'

export default function SelectEmpresa(props) {

    const dispatch = useDispatch()
    const empresa = useSelector(store => store.depta.empresa)
    const { obtenerBDhijo } = props;
    const { bd } = props;
 
    const handleChange = (event) => {
        obtenerBDhijo(event.target.value)
        dispatch(obtenerlistadepta(event.target.value))
    };

   
    React.useEffect(() => {
        const obtenerInfo = () => {
            dispatch(obtenerlistaempresa())
        }
        obtenerInfo()

    }, [dispatch])

    



    return (
        <Grid container alignItems="center" justifyContent="center" flexDirection='column'>
            <Grid item md={5} >
                <Typography variant='h3'>
                    Selección de nomina
                </Typography>
            </Grid>
            <Grid item md={5} >
                <Typography variant='h6'>
                    Selecciona la ubicación de la nomina para capturar incidencias
                </Typography>
            </Grid>
           
            <Grid item md={10} component={Paper} variant="outlined" padding={5}>

                <Typography variant="h6" >
                    Selecciona  el tipo de nomina
                </Typography>

                <FormControl variant="standard" sx={{ m: 2, minWidth: 300 }} fullWidth>
                    <InputLabel id="demo-simple-select-filled-label">Empresa</InputLabel>
                    <Select
                        fullWidth
                        labelId="demo-simple-select-filled-label"
                        id="demo-simple-select-filled"
                        value={bd === -1 ? '' : bd}
                        onChange={handleChange}
                    >
                        {empresa.map((row, Index) => (
                            <MenuItem key={Index} value={row.GUIDEmpresa}>{row.RutaEmpresa}</MenuItem>
                        ))}

                    </Select>
                </FormControl>

            </Grid>
        </Grid>
    );
}
